<prism-card
	[isFirstClick]="isFirstClick()"
	*transloco="let t"
	(shClickOutside)="clickedOutside($event)"
	id="sh-notification-popup-card"
>
	<div id="sh-notification-popup-header-div" class="sh-custom-dialog-container">
		<div id="sh-notification-popup-content-div">
			<div id="sh-notification-popup-text-div">
				<p id="sh-notification-popup-title-p">{{ t('cloud.shared.notification.title') }}</p>
				<p id="sh-notification-popup-current-date-p">{{ currentDateLabel }}</p>
			</div>
			<prism-icon-button
				id="sh-notification-popup-close-icon"
				icon="close"
				(click)="closedialog()"
			></prism-icon-button>
		</div>
		<div id="sh-notification-popup-buttons-div" class="sh-notification-popup-buttons">
			<prism-button (click)="notificationsList()" id="sh-notification-popup-view-all-button">
				{{ t('cloud.shared.notification.view-all') }}
			</prism-button>
			<prism-button
				[disabled]="unReadNotificationsDataLength() === 0"
				(click)="clearAll()"
				id="sh-notification-popup-close-button"
			>
				{{ t('cloud.shared.notification.mark-all-as-read') }}
			</prism-button>
		</div>
	</div>
	@if (isLoading()) {
		<div id="sh-notification-popup-loading-div">
			<prism-progress-indicator
				id="sh-notification-popup-list-progress-indicator"
				type="linear"
				mode="indeterminate"
				value="0"
				size="lg"
			></prism-progress-indicator>
		</div>
	}
	<div
		id="sh-notification-popup-list-container-div"
		class="sh-notification-popup-list-container"
		(scroll)="onNotificationListScroll($event)"
	>
		@if (unReadNotificationsDataLength() !== 0) {
			<prism-list id="sh-notification-list">
				@for (notification of notifications$ | async; track notification; let i = $index) {
					<prism-list-item
						label="list-item"
						class="sh-notification-popup-list-item"
						id="sh-notification-popup-popup-list-item-{{ i }}"
					>
						<div id="sh-notification-popup-list-item-div" class="sh-notification-popup-list-item-div">
							<div id="sh-notification-popup-dot-div" class="sh-notification-popup-dot"></div>
							<div
								id="sh-notification-popup-list-content-div"
								class="sh-notification-popup-list-content"
								(click)="openPopup(notification)"
							>
								<div
									id="sh-notification-popup-organization-name-div"
									class="sh-notification-popup-organization-name"
								>
									{{ t('cloud.shared.notification.organization') | uppercase }}:
									{{ notification?.organization?.name | uppercase }}
								</div>
								<div id="sh-notification-popup-subject-div" class="sh-notification-popup-subject">
									{{ notification.subject }}
								</div>
								<div id="sh-notification-popup-body-div" class="sh-notification-popup-body">
									{{ notification.body }}
								</div>
							</div>
							<prism-icon-button
								class="sh-notification-popup-clear-icon"
								id="sh-notification-popup-popup-clear-icon-{{ i }}"
								custom-icon="assets/icons/md/remove_circle_outline.svg"
								label="{{ t('common.buttons.clear') }}"
								size="medium"
								(click)="markAsRead(notification)"
							></prism-icon-button>
							<div id="sh-notification-popup-custom-date-div" class="sh-notification-popup-custom-date">
								{{ notification.sentAt }}
							</div>
						</div>
					</prism-list-item>
				}
			</prism-list>
		}
	</div>
	@if (unReadNotificationsDataLength() === 0) {
		@if (unReadNotificationsCalled()) {
			<div id="sh-notification-popup-no-notification">
				<p id="sh-notification-popup-no-notification-text">
					{{ t('cloud.shared.notification.no-notification') }}
				</p>
			</div>
		} @else {
			<div id="sh-notification-popup-no-notification">
				<p id="sh-notification-popup-no-notification-text">
					{{ t('cloud.shared.notification.loading') }}
				</p>
			</div>
		}
	}
</prism-card>
